var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover",class:_vm.tblClass,staticStyle:{"margin-bottom":"0"},style:(_vm.tblStyle)},[_c('colgroup',[(_vm.shouldRenderSelection)?_c('col',{staticStyle:{"width":"30px"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(col){return _c('col',{class:col.colClass,style:(col.colStyle)})})],2),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-299b1d1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_utilities/vue2-datatable/Table/TableFrame.vue
// module id = 350
// module chunks = 193